import type { MutationHookOptions } from "@apollo/client";
import { useMutation, gql } from "@apollo/client";

const OFFICE_RESEND_ALL_INVITATIONS_MUTATION = gql`
  mutation OfficeResendAllInvitations_UnauthenticatedSignUpSignIn_Mutation(
    $input: AuthOfficeResendAllInvitationsInput!
  ) {
    auth {
      officeResendAllInvitations(input: $input) {
        errors {
          message
          fields {
            email
          }
        }
      }
    }
  }
`;

interface AuthOfficeResendAllInvitationsFieldError {
  email: string[];
}

interface AuthOfficeResendAllInvitationsError {
  fields: AuthOfficeResendAllInvitationsFieldError;
  message: string;
}

interface OfficeResendAllInvitationsMutationData {
  auth: {
    officeResendAllInvitations: {
      errors: AuthOfficeResendAllInvitationsError;
    };
  };
}

interface OfficeResendAllInvitationsAttributes {
  email: string;
  storeId: string;
}

interface Variables {
  input: {
    captchaToken: string;
    attributes: OfficeResendAllInvitationsAttributes;
  };
}

const useOfficeResendAllInvitationsMutation = (
  options?: MutationHookOptions<OfficeResendAllInvitationsMutationData, Variables>
) =>
  useMutation<OfficeResendAllInvitationsMutationData, Variables>(
    OFFICE_RESEND_ALL_INVITATIONS_MUTATION,
    options
  );

export type { OfficeResendAllInvitationsMutationData };
export { useOfficeResendAllInvitationsMutation, OFFICE_RESEND_ALL_INVITATIONS_MUTATION };
